var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment-review d-flex align-items-center mb-3"},[_c('TacoRating',{attrs:{"only-tacos":true,"deal":_vm.mockDeal,"taco-ratio":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }